import React, { useEffect } from 'react';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../lib/styles';
import blockStyles from './GroupBlock_styles';
import { blocksSelector, groupBlockSelector } from './store/selectors';
import { connect } from 'react-redux';
import ContentBlock from './ContentBlock';
import HolidayBlock from './HolidayBlock';
import CoreBlock from './CoreBlock';
import SpacerBlock, {
  SpacerBlockData,
} from '../Collection/CollectionBlock/Blocks/SpacerBlock';
import { Icons } from '../../components/presentational/Icon';
import CardGridBlock from './CardGridBlock';
import ColumnBlock from './ColumnBlock';
import ContentLayoutBlock from './ContentLayoutBlock';
import CarouselBlock, {
  CarouselBlockData,
} from '../Collection/CollectionBlock/Blocks/CarouselBlock';
import { GroupBlock as GroupBlockModel } from '../../models/block';
import { Block } from './store/reducer';
import memoize from '../../lib/selectorUtils';
import { logger } from '../../server/logging';
import MultiSearchBlock from './MultiSearchBlock';
import TitleBlock from './TitleBlock';

//  the wrapping Group Block props
export interface GroupBlockProps extends GroupBlockModel {
  slug: string;
  title: string;
  subtitle: string;
  brand: string;
  blocks?: Block[];
}

export enum ButtonPosition {
  Above = 1,
  Below = 2,
  AboveAndBelow = 3,
}

export enum PositionWithinBlock {
  Above = 1,
  Right = 2,
  Below = 3,
  Left = 4,
}

//  these are default fields that form the basis for all custom block fields
export interface DefaultBlockFields {
  title: string;
  subtitle: string;
  cta_button: {
    label: string;
    href: string;
    target: string;
    block: boolean;
    icon: Icons;
    button_position: ButtonPosition;
  };
}

const GroupBlock = ({
  // slug,
  // title,
  // subtitle,
  // brand,
  blocks = [],
  styles,
}: GroupBlockProps & StylesProps<typeof blockStyles>) => {
  useEffect(() => {
    logger.debug('Group Block useEffect', { blocks });
  });

  // console.log('Group Block', {slug, title, subtitle, brand, styles});
  return (
    <div className={`${styles.container} blocks-container`}>
      {blocks.map((block: Block, i) => {
        // console.log('Group Block loop', {block, i});
        switch (block.type) {
          case 'acf_multisearch_block':
            // console.log('GroupBlock acf_multisearch_block', block);
            return <MultiSearchBlock key={i} {...block} />;
          case 'acf_content_block':
            return <ContentBlock key={i} {...block} />;
          case 'acf_title_block':
            return <TitleBlock key={i} {...block} />;
          case 'acf_holiday_block':
            return <HolidayBlock key={i} {...block} />;
          case 'acf_cardgrid_block':
            return <CardGridBlock key={i} {...block} />;
          case 'acf_columns_block':
            return <ColumnBlock key={i} {...block} />;
          case 'acf_contentlayout_block':
            return <ContentLayoutBlock key={i} {...block} />;
          case 'acf_spacer_block':
            const spacerData = {
              ...{ type: 'spacer_block' },
              ...{ ...block },
            } as unknown as SpacerBlockData;
            return <SpacerBlock key={i} {...spacerData} />;
          case 'acf_carousel_block':
            const carouselData = {
              ...{ type: 'carousel_block' },
              ...{ ...block },
            } as unknown as CarouselBlockData;
            console.log('Carousel Block', { carouselData });
            return <CarouselBlock key={i} block={carouselData} />;
          case 'core_heading_block':
          case 'core_paragraph_block':
          case 'core_cover_block':
          case 'core_columns_block':
          case 'core_list_block':
          case 'core_group_block':
            return <CoreBlock key={i} {...block} />;
          default:
            console.error('Block type not configured', { block });
            return <></>;
        }
      })}
    </div>
  );
};

const groupBlockPropsSelector = memoize(groupBlockSelector, groupBlock => ({
  ...groupBlock,
}));

export default compose(
  connect(groupBlockPropsSelector),
  styled(blockStyles)
)(GroupBlock);
